import Map from "can/map/";
import "can/map/define/";

const AppViewModel = Map.extend({
    define: {
        // By default, viewModel attributes will not be serialized into the URL as route attributes.
        "*": {
            serialize: false
        },
        // We want the `page`, `slug` and `id` attribute to show in the URL, so `serialize = true`.
        page: {
            serialize: true
        },
        slug: {
            serialize: true
        },
        id: {
            serialize: true
        },
        date: {
            serialize: true
        },
        user: {
            value: "Loading..."
        },
        account: {
            value: "Loading..."
        },
        hasMobileWorkerPermission: {
            value: false
        },
        hasIftaPermission: {
            value: false
        },
        hasHosPermission: {
            value: false
        },
         canAccessCurrentRoute: {
            value: false
        },
        hasDvirPermission: {
            value: false
        },
        isMobileWorker: {
            value: false
        },
        isNotDriver: {
            value: true
        },
        isReseller: {
            value: false
        },
        hasProducts: {
            value: false
        },
        licenseManagement: {
            value: false
        },
        isUserRoleAdmin: {
            value: false
        },
        canReassignDrivingEvents: {
            value: false
        },
        isUserRoleAssetAdmin: {
            value: false
        },
        canViewSubAccounts: {
            value: false
        },
        isUserRoleVTAdmin: {
            value: false
        },
        isDriverLogin: {
            value: false
        },
        allowSubAccountBranding: {
            value: false
        },
        refreshRateInterval: {
            value: 120
        },
        hasIftaFeatures: {
            value: false
        },
        hasMapFeatures: {
            value: false
        },
        hasEldFeatures: {
            value: false
        },
        hasDvirFeatures: {
            value: false
        },
        hasWorkOrderFeatures: {
            value: false
        },
        hasComplianceSupportCenterFeatures: {
            value: false
        },
        hideFuelReceipts: {
            value: true
        },
        accountLogo: {
            value: ""
        },
        isAccountLogoError: {
            value: false
        },
        isHideRefreshBtn: {
            value: false
        },
        hideLogout: {
            value: false
        },
        hideLogShowEdits: {
            value: false
        },
        themeColor: {
            value: "theme-blue"
        },
    },
    permissions: [],
    hiddenReports: [],
    enableRefreshButton: true,
    loadingClassname:"loading",
    products: {
        hosOnly: false,
        dvirOnly: false,
        hosAndDvir: false,
        mobileWorkerOnly: false,
        hosAndMobileWorker: false,
        dvirAndMobileWorker: false,
        hosDvirAndMobileWorker: false
    }
});

export default AppViewModel;
